import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

export interface FormValidationError {
  controlName: string;
  errorName: string;
  errorValue: any;
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}

export function getFormValidationErrors(controls: FormGroupControls): FormValidationError[] {
  let errors: FormValidationError[] = [];

  Object.keys(controls).forEach(key => {
    const control = controls[ key ];

    if (control instanceof FormGroup) {
      errors = errors.concat(getFormValidationErrors(control.controls));
    }

    const controlErrors: ValidationErrors = controls[ key ].errors;

    if (controlErrors !== null) {
      Object.keys(controlErrors).forEach(keyError => {
        if (keyError == 'pattern') keyError = 'invalid';
        
        errors.push({
          controlName: key,
          errorName: keyError,
          errorValue: controlErrors[ keyError ]
        });
      });
    }
  });
  
  return errors;
}